import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Scissors, CornerDownRight, Flame, CheckCircle } from 'lucide-react';

const steps = [
  { key: 'step1', icon: Scissors },
  { key: 'step2', icon: CornerDownRight },
  { key: 'step3', icon: Flame },
  { key: 'step4', icon: CheckCircle },
];

export default function ProcessSection() {
  const { t } = useLanguage();

  return (
    <section id="process" data-testid="process-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-8 h-px bg-[#003865]" />
            <span
              className="text-xs font-bold uppercase tracking-[0.2em] text-[#003865]"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              {t('process.overline')}
            </span>
            <div className="w-8 h-px bg-[#003865]" />
          </div>
          <h2
            data-testid="process-title"
            className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#333F48]"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            {t('process.title')}
          </h2>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0">
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <div
                key={step.key}
                data-testid={`process-${step.key}`}
                className={`relative p-8 lg:p-10 border border-[#C8C9C7] ${i > 0 ? 'lg:border-l-0' : ''}`}
              >
                {/* Step number */}
                <div
                  className="text-6xl font-bold text-[#C8C9C7]/40 absolute top-4 right-6"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {String(i + 1).padStart(2, '0')}
                </div>

                <div className="relative z-10">
                  <div className="w-12 h-12 flex items-center justify-center border border-[#003865] text-[#003865] mb-6">
                    <Icon size={22} strokeWidth={1.5} />
                  </div>

                  <h3
                    className="text-lg font-bold text-[#333F48] mb-3"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {t(`process.${step.key}.title`)}
                  </h3>
                  <p
                    className="text-sm leading-relaxed text-[#333F48]/70"
                    style={{ fontFamily: 'Roboto, sans-serif' }}
                  >
                    {t(`process.${step.key}.desc`)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
